import { FC } from 'react';

import Block from '../../../../../components/Block';
import Column from '../../../../../components/Column';

import { CampaignAdGroup } from '../../../../../types/Campaign';
import CampaignAdGroupOverviewCard from '../Card/CampaignAdGroupOverviewCard';
import CampaignAdGroupInventoryCard from '../Card/CampaignAdGroupInventoryCard';

interface CampaignAdGroupOverviewTabProps {
    campaignAdGroup: CampaignAdGroup;
}

const CampaignAdGroupOverviewTab: FC<CampaignAdGroupOverviewTabProps> = ({ campaignAdGroup }) => {
    return (
        <Block disableGutters px={3}>
            <Column gap={4}>
                <CampaignAdGroupOverviewCard campaignAdGroup={campaignAdGroup} />

                <CampaignAdGroupInventoryCard campaignAdGroup={campaignAdGroup} />
            </Column>
        </Block>
    );
};

export default CampaignAdGroupOverviewTab;
